import { render, staticRenderFns } from "./app-diy-form.vue?vue&type=template&id=2f0be0d9&"
import script from "./app-diy-form.vue?vue&type=script&lang=js&"
export * from "./app-diy-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports